import { AfterContentInit, Directive, ElementRef, Input, Renderer2, inject } from '@angular/core';

import { AnalyticsTracks } from '@shared/models/analytics.model';

import { AnalyticsMediator } from '@shared/services/analytics-mediator.service';

@Directive({
  selector: '[analyticsTrack]',
  standalone: false,
})
export class AnalyticsTracker implements AfterContentInit {
  private eRef = inject(ElementRef);
  private analytics = inject(AnalyticsMediator);
  private renderer = inject(Renderer2);

  @Input('analyticsTrackOn') event: string = 'click';
  @Input('analyticsTrack') track: AnalyticsTracks;

  ngAfterContentInit() {
    this.renderer.listen(this.eRef.nativeElement, this.event, () => {
      this.analytics.track(this.track);
    });
  }
}
